// extracted by mini-css-extract-plugin
module.exports = {"tagCard":"tags-module--tagCard--2sNqZ","tagImg":"tags-module--tagImg--21WVr","pd20px":"tags-module--pd20px--1m4en"};